import React, {Component} from 'react';
import {connect} from 'react-redux';
import {ConnectedRouter} from 'react-router-redux';
import history from './history';
import NotificationsSystem from 'reapop';
import theme from './notifications/reapop/reapop-theme-bootstrap';

// Global css
// import './css/bootstrap/bootstrap.css';
import './css/main.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';

// Structural elements
import LeftSidebar from './elements/left-sidebar';
import RightSidebar from './elements/right-sidebar';
import Navbar1 from './elements/navbar-1';
import Navbar2 from './elements/navbar-2';
import TopNavigation1 from './elements/top-navigation-1';
import { push } from 'react-router-redux';
// import Jumbotron from './elements/jumbotron';
import Backdrops from './elements/backdrops';
import Routes from './Routes';

import store from 'store2';
import { fetchUserByIdForProfile } from './api/users';
import { setAuth } from './actions/auth';
import { setConfig } from './actions/config';
import CheckExpiredSession, { checkExpiresSession } from './containers/CheckExpiredSession/CheckExpiredSession';

class App extends Component {

  componentDidUpdate() {
    const authUser = store.get('user');
    if(authUser !== null) {
      checkExpiresSession(authUser);
    }
  }

  componentWillMount() {
    const authUser = store.get('user');
    if(authUser && Object.keys(authUser).length > 0) {
      this.props.setAuth(authUser);
      this.props.setUserProfile(authUser.userId);
    } else {
      if (window.location.href.indexOf('pages/quote-pre-view/') !== -1){
        return;
      }
      this.props.redirectToLogin();
    }
    if (window.location.href.indexOf('pages/dashboards') !== -1 && window.location.href.indexOf('pages/dashboards-') === -1) {
      this.props.setConfig('collapsed', false);
    }
  }

  render() {
    let {
      layout,
      background,
      navbar,
      topNavigation,
      logo,
      leftSidebar,
      collapsed
    } = this.props.config;
    let isEmptyView = layout === 'empty-view-1' ? true : false;

    if (window.location.href.indexOf('pages/quote-pre-view/') !== -1) {
      return (
        <ConnectedRouter history={history}>
          <Routes />
        </ConnectedRouter>
      )
    }

    const sidebar = localStorage.getItem('sidebar')
    if (sidebar) {
      layout = sidebar
    }
    return (
      <ConnectedRouter history={history}>
        <div
          data-layout={layout}
          data-background={background}
          data-navbar={navbar}
          data-top-navigation={topNavigation}
          data-logo={logo}
          data-left-sidebar={leftSidebar}
          data-collapsed={collapsed}>
          <NotificationsSystem theme={theme} />
          <Backdrops />
          <RightSidebar />
          <Navbar1 />
          <Navbar2 />
          <TopNavigation1 />
          <div className={isEmptyView ? '' : 'container-fluid'}>
            <div className={isEmptyView ? '' : 'row'}>
              <LeftSidebar />
              <div className="col main">
                <Routes />
              </div>
            </div>
          </div>
          <CheckExpiredSession/>
        </div>
      </ConnectedRouter>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    auth: state.auth,
    config: state.config
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    redirectToLogin: () => {
      dispatch(push('/pages/login'));
    },
    setConfig: (key, value) => dispatch(setConfig(key, value)),
    setUserProfile: (id) => {
      fetchUserByIdForProfile(id)(dispatch);
    },
    setAuth: (data) => {
      dispatch(setAuth(data));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js